export enum InvoiceType {
  Regular = 1,
  Refund = 2,
  Credit = 4,
  Cancellation = 5,
  Recurring = 6,
}
